var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarTermbases = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "m11.87 13.07-2.54-2.51.03-.03A17.5 17.5 0 0 0 13.07 4H16V2H9V0H7v2H0v1.99h11.17C10.5 5.92 9.44 7.75 8 9.35 7.07 8.32 6.3 7.19 5.69 6h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L3 17l5-5 3.11 3.11zM17.5 8h-2L11 20h2l1.12-3h4.75L20 20h2zm-2.62 7 1.62-4.33L18.12 15z"
})));
export default SvgSidebarTermbases;